import { buildTask as _buildTask } from "ember-concurrency/-private/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
import { action, get } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { format, getDate, addMinutes, startOfDay, isAfter, isToday, isEqual, fromUnixTime } from 'date-fns';
import { task } from 'ember-concurrency';
import config from 'garaje/config/environment';
import { APPROVAL_STATUS, INVITE_STATE } from 'garaje/utils/enums';
import { parseErrorForDisplay } from 'garaje/utils/flash-promise';
import InviteStateLabel from 'garaje/utils/invite-state-label';
let DayAvailabilityComponent = (_class = class DayAvailabilityComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "flashMessages", _descriptor, this);
    _initializerDefineProperty(this, "state", _descriptor2, this);
    _initializerDefineProperty(this, "metrics", _descriptor3, this);
    _initializerDefineProperty(this, "registrations", _descriptor4, this);
    _initializerDefineProperty(this, "featureConfig", _descriptor5, this);
    _initializerDefineProperty(this, "workplaceMetrics", _descriptor6, this);
    _initializerDefineProperty(this, "unscheduleModalIsOpen", _descriptor7, this);
    _initializerDefineProperty(this, "unscheduleError", _descriptor8, this);
    _defineProperty(this, "INVITE_STATE_ENUM", INVITE_STATE);
    _defineProperty(this, "unscheduleTask", _buildTask(() => ({
      context: this,
      generator: function* () {
        this.unscheduleError = false;
        try {
          const {
            invite,
            reservation
          } = yield this.registrations.unschedule(this.args.date, {
            reservation: this.args.reservation
          });
          this.metrics.trackEvent('Web Employee Schedule - Unschedule', {
            desk_id: reservation?.desk?.id,
            invite_date: invite.expectedArrivalTime,
            invite_id: invite.id,
            invite_location_id: invite.location.id,
            reservation_id: reservation?.id
          });
          this.unscheduleModalIsOpen = false;
          this.flashMessages.showAndHideFlash('success', 'Reservation released');
        } catch (e) {
          this.unscheduleError = true;
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unnecessary-type-assertion, @typescript-eslint/no-explicit-any
          this.flashMessages.showAndHideFlash('error', parseErrorForDisplay(e.errors?.firstObject));
        }
      }
    }), {
      drop: true
    }, "unscheduleTask", null));
    _defineProperty(this, "scheduleTask", _buildTask(() => ({
      context: this,
      generator: function* () {
        const {
          date
        } = this.args;
        this.workplaceMetrics.trackEvent('YOUR_SCHEDULE_SCHEDULE_BTN_CLICKED');
        try {
          const {
            reservation,
            invite
          } = yield this.registrations.reserveDesk(date);
          this.workplaceMetrics.trackEvent('YOUR_SCHEDULE_SCHEDULE_SUCCESS');
          this.metrics.trackEvent('Web Employee Schedule - Schedule', {
            desk_id: reservation?.desk.id,
            invite_date: invite.expectedArrivalTime,
            invite_id: invite.id,
            invite_location_id: invite.location.id,
            reservation_id: reservation?.id
          });
          // @ts-ignore there is no variable called bookDeskEnabled
          if (reservation || !this.bookDeskEnabled) {
            this.flashMessages.showAndHideFlash('success', 'Reservation scheduled');
          } else {
            this.flashMessages.showAndHideFlash('error', 'Desk could not be booked at this time');
          }
        } catch (e) {
          this.workplaceMetrics.trackEvent('YOUR_SCHEDULE_SCHEDULE_FAILED');
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unnecessary-type-assertion, @typescript-eslint/no-explicit-any
          this.flashMessages.showAndHideFlash('error', parseErrorForDisplay(e.errors?.firstObject));
        }
      }
    }), {
      drop: true
    }, "scheduleTask", null));
    _defineProperty(this, "releaseDeskReservationTask", _buildTask(() => ({
      context: this,
      generator: function* () {
        const {
          reservation
        } = this.args;
        try {
          yield this.registrations.releaseDeskReservation({
            reservation
          });
          this.metrics.trackEvent('Web Employee Schedule - Release Desk', {
            reservation_id: reservation.id,
            desk_id: reservation.desk.id
          });
          this.flashMessages.showAndHideFlash('success', 'Desk released');
        } catch (e) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unnecessary-type-assertion, @typescript-eslint/no-explicit-any
          this.flashMessages.showAndHideFlash('error', parseErrorForDisplay(e.errors?.firstObject));
        }
      }
    }), {
      drop: true
    }, "releaseDeskReservationTask", null));
    _defineProperty(this, "signInInviteTask", _buildTask(() => ({
      context: this,
      generator: function* () {
        const {
          screeningCard,
          reservation,
          date
        } = this.args;
        this.workplaceMetrics.trackEvent('YOUR_SCHEDULE_SIGN_IN_BTN_CLICKED');
        try {
          const entry = yield this.registrations.signInInvite(date);
          this.workplaceMetrics.trackEvent('YOUR_SCHEDULE_SIGN_IN_SUCCESS');
          this.metrics.trackEvent('Web Employee Schedule - Sign In', {
            desk_id: reservation?.desk.id,
            entry_flow_name: entry.flowName,
            entry_id: entry.id,
            entry_location_id: entry.location.id,
            invite_date: screeningCard.expectedArrivalTime,
            invite_id: screeningCard.id,
            reservation_id: reservation?.id
          });
          this.flashMessages.showAndHideFlash('success', 'Signed in');
        } catch (e) {
          this.workplaceMetrics.logMonitorError({
            event: 'YOUR_SCHEDULE_SIGN_IN_FAILED',
            error: e
          });
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unnecessary-type-assertion, @typescript-eslint/no-explicit-any
          this.flashMessages.showAndHideFlash('error', parseErrorForDisplay(e.errors?.firstObject));
        }
      }
    }), {
      drop: true
    }, "signInInviteTask", null));
    _defineProperty(this, "signOutEntryTask", _buildTask(() => ({
      context: this,
      generator: function* () {
        const {
          date,
          reservation,
          screeningCard
        } = this.args;
        try {
          const entry = yield this.registrations.signOutEntry(date);
          this.metrics.trackEvent('Web Employee Schedule - Sign Out', {
            desk_id: reservation?.desk.id,
            employee_entry_sign_out_at: entry.signedOutAt,
            entry_date: entry.signedInAt,
            entry_flow_name: entry.flowName,
            entry_id: entry.id,
            entry_location_id: entry.location.id,
            invite_id: screeningCard.id,
            reservation_id: reservation?.id
          });
          this.flashMessages.showAndHideFlash('success', 'Signed out');
        } catch (e) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unnecessary-type-assertion, @typescript-eslint/no-explicit-any
          this.flashMessages.showAndHideFlash('error', parseErrorForDisplay(e.errors?.firstObject));
        }
      }
    }), {
      drop: true
    }, "signOutEntryTask", null));
  }
  get showDelegatedBookerName() {
    return !!this.delegatedBookerName;
  }
  get delegatedBookerName() {
    if (!this.invite?.employee?.email || !this.invite?.visitor?.email) {
      return null;
    }
    if (this.invite.employee.email === this.invite.visitor.email) {
      return null;
    }
    return this.invite.employee.name;
  }
  get darkMode() {
    return [INVITE_STATE.SCHEDULED, INVITE_STATE.APPROVED, INVITE_STATE.PENDING, INVITE_STATE.SIGNED_IN].includes(this.inviteState);
  }
  get errorMode() {
    return [INVITE_STATE.DENIED, INVITE_STATE.PAST_WINDOW].includes(this.inviteState);
  }
  get dayOfWeek() {
    return format(this.args.date, 'eee');
  }
  get date() {
    return getDate(this.args.date);
  }
  get reservationDate() {
    return fromUnixTime(this.args.reservation.startTime);
  }
  get spotsRemaining() {
    return this.args.maxOccupancy - this.args.peopleRegistered;
  }
  get atCapacity() {
    return this.spotsRemaining === 0;
  }
  get schedulingBlocked() {
    return this.atCapacity && this.args.location.capacityLimitEnabled;
  }
  get approvalStatus() {
    return this.invite?.approvalStatus?.status;
  }
  get isApproved() {
    return this.approvalStatus == APPROVAL_STATUS.APPROVED;
  }
  get isDenied() {
    return this.approvalStatus == APPROVAL_STATUS.DENIED;
  }
  get invite() {
    return this.args.screeningCard?.__typename == 'Invite' ? this.args.screeningCard : null;
  }
  get inviteStateLabel() {
    return InviteStateLabel(this.inviteState);
  }
  get isNotRegistered() {
    return !this.isApproved && !this.isDenied;
  }
  get screeningWindowStarted() {
    const {
      registrationEligibilityStartOffset,
      employeeScreeningFlow
    } = this.args.location;
    // eslint-disable-next-line ember/no-get
    if (employeeScreeningFlow && !get(employeeScreeningFlow, 'employeeScreeningRequired')) {
      return true;
    }
    const startOfWindow = addMinutes(startOfDay(this.args.date), registrationEligibilityStartOffset ?? 0);
    return isAfter(new Date(), startOfWindow) || isEqual(new Date(), startOfWindow);
  }
  get screeningWindowEnded() {
    const {
      registrationEligibilityEndOffset,
      employeeScreeningFlow
    } = this.args.location;
    // eslint-disable-next-line ember/no-get
    if (employeeScreeningFlow && !get(employeeScreeningFlow, 'employeeScreeningRequired')) {
      return false;
    }
    const endOfWindow = addMinutes(startOfDay(this.args.date), registrationEligibilityEndOffset || 0);
    return isAfter(new Date(), endOfWindow) || isEqual(new Date(), endOfWindow);
  }
  get isToday() {
    return isToday(this.args.date);
  }
  get isRegistered() {
    return this.invite.isPresigned || !this.preregistrationLink;
  }
  get preregistrationLink() {
    return this.invite.preregistrationLink;
  }
  get registerUrl() {
    const garajeReturnUrl = `${config.host}/schedule%3FselectedInviteId%3D${this.invite.id}`;
    return this.noRequiredDocumentApproval ? null : `${this.preregistrationLink}?garajeReturnUrl=${garajeReturnUrl}`;
  }
  get isEditReservationConfigEnabled() {
    return this.featureConfig.isEnabled('deskReservations.editing');
  }
  get isCancelReservationConfigEnabled() {
    return this.featureConfig.isEnabled('deskReservations.canceling');
  }
  get noRequiredDocumentApproval() {
    const {
      date,
      requiredDocumentApprovalExpiresAt,
      hasRequiredDocumentApproval
    } = this.args;
    const isExpiredDocument = requiredDocumentApprovalExpiresAt && (isAfter(date, new Date(requiredDocumentApprovalExpiresAt)) || isEqual(date, new Date(requiredDocumentApprovalExpiresAt)));
    return isExpiredDocument || !hasRequiredDocumentApproval;
  }
  get inviteState() {
    if (this.isNotRegistered) {
      if (this.screeningWindowEnded) {
        return INVITE_STATE.PAST_WINDOW;
      } else if (!this.invite) {
        return INVITE_STATE.UNSCHEDULED;
      }
      return INVITE_STATE.SCHEDULED;
    } else {
      if (!this.invite.entry) {
        // registered states
        if (this.isApproved) return INVITE_STATE.APPROVED;
        if (this.isDenied) return INVITE_STATE.DENIED;
        return INVITE_STATE.PENDING;
      }
      return INVITE_STATE.SIGNED_IN;
    }
  }
  closeUnscheduleModal() {
    this.unscheduleError = false;
    this.unscheduleModalIsOpen = false;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "flashMessages", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "state", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "metrics", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "registrations", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "featureConfig", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "workplaceMetrics", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "unscheduleModalIsOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "unscheduleError", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "closeUnscheduleModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeUnscheduleModal"), _class.prototype)), _class);
export { DayAvailabilityComponent as default };